export const TARGETS_SELECT = 'multi-target-selection/TARGETS_SELECT';
export const TARGETS_DESELECT = 'multi-target-selection/TARGETS_DESELECT';
export const TARGETS_RESET = 'multi-target-selection/TARGETS_RESET';

/**
 * Selects a list of targets.
 *
 * @param {Array<Object>} targets Array of GQL objects to select. These must include the id property.
 */
export const selectTargets = targets => {
  return { type: TARGETS_SELECT, targets };
};

/**
 * Deselects a list of targets.
 *
 * @param {Array<Object>} targets Array of GQL objects to deselect. These must include the id property.
 */
export const deselectTargets = targets => {
  return { type: TARGETS_DESELECT, targets };
};

export const resetTargets = () => {
  return { type: TARGETS_RESET };
};
